document.addEventListener("DOMContentLoaded", () => {
  const formRootDiv = document.querySelector("[data-form-root]")
  // if there's not Shopify Form on the page, do nothing
  if (!formRootDiv) return

  // Watch for Shopify Forms initialized form-embed element
  new MutationObserver((_mutations, obs) => {
    const formEmbedEl = document.querySelector("form-embed")
    if (!formEmbedEl?.shadowRoot) return

    // Apply styles to shadow root
    const sheet = new CSSStyleSheet()
    sheet.replaceSync(`
      ._formHeader_1nihh_19 {
        display: none;
      }
      form {
        --form-field-border-radius: 0;
        --button-border-radius: 2px;
        --button-background-color: #65449b;
        --form-field-border: 0 0 0 1px #000;
        --form-placeholder-color: #000;
        display: flex !important;
        flex-direction: row !important;
        flex-wrap: wrap !important;
        gap: 12px !important;
        padding: 20px 0 !important;
      }
      form > div {
        flex: 1;
        flex-basis: calc(50% - 6px) !important;
      }
      form input:not([type="checkbox"]),
      form [class*="_selectContainer_"] > button {
        margin: 2px !important;
        height: 46px !important;
        box-sizing: border-box !important;
      }
      #form-container-ref > section:first-child,
      #form-container-ref > section:first-child > section {
        overflow: initial !important;
      }
      ._optionList_1yit2_83 {
        overflow: auto !important;
        max-height: 80px;
      }
      form div:has(input[id="custom#version"]) {
        display: none;
      }
      form [class*="_selectContainer_"] > button {
        width: calc(100% - 4px) !important;
      }
      form label {
        margin-top: 3px !important;
      }
      form input:focus + label,
      form label[class*="_inputFilled_"] {
        margin-top: 0 !important;
      }
      form > button {
        flex-basis: 50% !important;
        margin: 0 auto !important;
      }
      [data-testid="form-container"][data-sizing="form-wrapper"]{
        max-width: initial;
        margin: 0;
      }
      form div:has([aria-controls="custom#frequency_band_needed-selector-dropdown"]) > p {
        pointer-events: none;
        z-index: 1;
        font: var(--forms-body-font);
        line-height: 1;
        color: var(--form-placeholder-color);
        position: absolute;
        left: var(--form-field-padding);
        top: var(--input-label-top);
        max-width: calc(100% - var(--form-field-padding)* 2);
        word-break: keep-all;
        overflow-wrap: break-word;
        margin: 0;
        transform-origin: top left;
        transform: none;
        transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;

        top: 16px;
        margin-top: 3px;

        &:has(+ button > [class*="_selectToggleText_"]:not(:empty)) {
          transform: var(--input-label-transform);
          margin-top: 0;
        }
      }
      form div:has([aria-controls="custom#frequency_band_needed-selector-dropdown"]) > button {
        padding-top: 21px !important;
        & > span:first-child {
          overflow: initial;
        }
        & > span:nth-child(2) {
          translate: 0 -6px !important;
        }
      }
    `)
    formEmbedEl.shadowRoot.adoptedStyleSheets = [...formEmbedEl.shadowRoot.adoptedStyleSheets, sheet]

    // Move form to modal location
    const targetContainer = document.querySelector("#modal-request-a-quote .product-block-list__item .rte")
    targetContainer && targetContainer.appendChild(formEmbedEl)

    document.dispatchEvent(new CustomEvent("request-a-quote:form-ready", { bubbles: true }))

    // We found and processed the form element, disconnect observer
    obs.disconnect()
  }).observe(formRootDiv, { childList: true, subtree: true })
})
